import * as React from "react";
import ActionButton from "../../../repertoire/components/actionButton/ActionButton";
import { CURRENT_USER_EMAIL_KEY } from "../../../redux/services/AccountSessionStorage";
import { useState } from "react";

interface PackageMessageData {
    fields: ReadonlyArray<{
        name: string;
        data: string;
    }>;
}

interface CreateFullCataloguePackageButtonProps<TCriteria> {
    buttonText: string;
    fullCataloguePackagePending?: boolean;
    saveInProgress?: boolean;
    disabled?: boolean;
    createPackageFromCriteria?: (userName: string, criteria: TCriteria) => any;
    buildCriteria: () => TCriteria;
    searchViewData?: PackageMessageData;
}

const CreateFullCataloguePackageButton = <TCriteria extends object,>({
    buttonText,
    fullCataloguePackagePending,
    saveInProgress,
    disabled,
    createPackageFromCriteria,
    buildCriteria,
    searchViewData,
}: CreateFullCataloguePackageButtonProps<TCriteria>) => {
    const [messageText, setMessageText] = useState("");
    const [messageType, setMessageType] = useState<"success" | "error" | undefined>(undefined);
    const [isProcessing, setIsProcessing] = useState(false);

    const isDisabled = Boolean(disabled) || Boolean(fullCataloguePackagePending) || isProcessing;
    const processingText =
        searchViewData?.fields?.find(
            field =>
                field.name?.toString() === "addingToPackageLabel"
        )?.data || "Adding...";

    const handleClick = async () => {
        if (isDisabled || !createPackageFromCriteria) {
            return;
        }

        const userName = sessionStorage.getItem(CURRENT_USER_EMAIL_KEY);
        if (!userName) {
            return;
        }

        setIsProcessing(true);

        try {
            const result = await createPackageFromCriteria(userName, buildCriteria());

            const messageKey =
                Array.isArray(result?.messages) &&
                result.messages.length > 0
                    ? result.messages[0]?.messageKey
                    : undefined;

            const configuredMessage =
                searchViewData?.fields?.find(
                    field => field.name?.toString() === messageKey
                )?.data;

            setMessageType(result?.success ? "success" : "error");
            setMessageText(
                configuredMessage ||
                (result?.success
                    ? "Full catalogue added to package"
                    : "Could not add full catalogue to package")
            );

            setTimeout(() => setMessageText(""), 5000);
        } catch {
            setMessageType("error");
            setMessageText(
                "Could not add full catalogue to package"
            );
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <div className="createFullCataloguePackageButton">
            <div className="fullCatalogueTooltipAnchor">
                <ActionButton
                    type="button"
                    buttonText={
                        isProcessing
                            ? processingText
                            : buttonText
                    }
                    buttonAction={handleClick}
                    disabled={isDisabled}
                />

                {messageText && (
                    <div
                        className={`messageBox fullCatalogueTooltip ${
                            messageType === "error"
                                ? "addtopackageerrorMessage"
                                : "addtopackagesuccessMessage"
                        }`}
                    >
                        {messageText}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreateFullCataloguePackageButton;
